/**
 * Small badge components shared across the issue surfaces. The
 * status / type / source → visual-variant mapping is a shell concern,
 * so it lives here rather than in shared-core.
 */
import { Badge } from "../../primitives/badge";
import { Lock } from "lucide-react";
import { issueStatusLabel, issueTypeLabel } from "@shared-core/domain/issues";

type BadgeVariant = "success" | "warning" | "error" | "neutral" | "outline";

function statusVariant(status: string): BadgeVariant {
  switch (status) {
    case "resolved":
      return "success";
    case "investigating":
      return "warning";
    case "open":
      return "error";
    default:
      return "neutral";
  }
}

export function IssueStatusBadge({ status }: { status: string }) {
  return (
    <Badge variant={statusVariant(status)}>{issueStatusLabel(status)}</Badge>
  );
}

export function IssueTypeBadge({ type }: { type: string }) {
  return <Badge variant="outline">{issueTypeLabel(type)}</Badge>;
}

export function IssueSourceBadge({ source }: { source: string }) {
  if (source === "legacy") {
    return (
      <Badge variant="neutral" className="gap-1">
        <Lock className="w-3 h-3" />
        Legacy
      </Badge>
    );
  }
  return <Badge variant="outline">Platform</Badge>;
}
